import styled from 'styled-components';

export const Page = styled.main`
  background: #0a1424;
  min-height: 100vh;
  color: #ffffff;
`;

export const Hero = styled.section`
  max-width: 1240px;
  margin: 0 auto;
  padding: 2.2rem 1rem 2rem;
  text-align: center;

  .badge {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    border: 1px solid rgba(240, 200, 118, 0.35);
    background: rgba(196, 152, 14, 0.15);
    color: #f3d99a;
    border-radius: 999px;
    padding: 0.35rem 0.9rem;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }

  h1 {
    margin: 0 0 0.6rem;
    font-family: 'Poppins', sans-serif;
    font-size: clamp(2rem, 5vw, 3.4rem);
  }

  p {
    margin: 0 auto;
    max-width: 72ch;
    color: #dbeafe;
    line-height: 1.7;
  }
`;

export const IconRow = styled.div`
  margin-top: 1.45rem;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;

  @media (max-width: 800px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const IconItem = styled.div`
  border: 1px solid rgba(240, 200, 118, 0.2);
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.72);
  padding: 0.8rem;

  i {
    color: #f3d99a;
    font-size: 1.15rem;
    margin-bottom: 0.35rem;
  }

  span {
    display: block;
    font-size: 0.84rem;
    color: #e2e8f0;
    font-weight: 600;
  }
`;

export const Body = styled.section`
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 1rem 3rem;
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 1rem;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const Toc = styled.aside`
  position: sticky;
  top: 92px;
  align-self: start;
  background: rgba(15, 23, 42, 0.78);
  border: 1px solid rgba(240, 200, 118, 0.2);
  border-radius: 16px;
  padding: 0.9rem;

  h4 {
    margin: 0 0 0.65rem;
    font-size: 0.92rem;
    display: flex;
    align-items: center;
    gap: 0.45rem;
    color: #f3d99a;
  }

  @media (max-width: 980px) {
    position: static;
  }
`;

export const TocLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 10px;
  padding: 0.52rem 0.6rem;
  margin-bottom: 0.35rem;
  color: ${({ $active }) => ($active ? '#fef3c7' : '#dbeafe')};
  background: ${({ $active }) => ($active ? 'rgba(196, 152, 14, 0.24)' : 'transparent')};
  text-decoration: none;
  font-size: 0.84rem;
  font-weight: 600;
`;

export const Main = styled.div`
  display: grid;
  gap: 0.95rem;
`;

export const DocSection = styled.section`
  border: 1px solid rgba(240, 200, 118, 0.2);
  border-radius: 18px;
  background: rgba(15, 23, 42, 0.78);
  padding: 1rem;

  h2 {
    margin: 0 0 0.55rem;
    display: flex;
    align-items: center;
    gap: 0.55rem;
    font-family: 'Poppins', sans-serif;
    font-size: clamp(1.2rem, 2.5vw, 1.65rem);
    color: #ffffff;
  }

  h2 i {
    color: #f3d99a;
  }

  p {
    margin: 0;
    color: #dbeafe;
    line-height: 1.7;
  }
`;

export const CardGrid = styled.div`
  margin-top: 0.9rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoCard = styled.article`
  border: 1px solid rgba(240, 200, 118, 0.2);
  border-radius: 14px;
  background: rgba(2, 6, 23, 0.42);
  padding: 0.9rem;

  .ico {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: rgba(196, 152, 14, 0.18);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #f3d99a;
    margin-bottom: 0.55rem;
  }

  h3 {
    margin: 0 0 0.35rem;
    color: #ffffff;
    font-size: 0.98rem;
  }

  p {
    color: #cbd5e1;
    font-size: 0.86rem;
    line-height: 1.65;
  }
`;

export const ConfidenceCard = styled.div`
  margin-top: 0.9rem;
  border: 1px solid rgba(240, 200, 118, 0.2);
  border-radius: 14px;
  background: rgba(2, 6, 23, 0.42);
  padding: 0.9rem;

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.4rem;
    font-size: 0.86rem;
    color: #e2e8f0;
  }

  p {
    margin-top: 0.7rem;
    font-size: 0.86rem;
    color: #cbd5e1;
  }
`;

export const Track = styled.div`
  width: 100%;
  height: 14px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.2);
  overflow: hidden;
  margin-bottom: 0.6rem;
`;

export const Fill = styled.div`
  height: 100%;
  width: ${({ $w }) => $w || '0%'};
  border-radius: 999px;
  background: linear-gradient(90deg, #b47806 0%, #f0c876 100%);
`;

export const ToolList = styled.ul`
  margin: 0.8rem 0 0;
  padding-left: 0;
  list-style: none;

  li {
    color: #dbeafe;
    font-size: 0.88rem;
    line-height: 1.65;
    margin-bottom: 0.35rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  i {
    color: #22c55e;
  }
`;

export const TipGrid = styled.div`
  margin-top: 0.9rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const TipCard = styled.article`
  border: 1px solid rgba(240, 200, 118, 0.2);
  border-radius: 14px;
  background: rgba(2, 6, 23, 0.42);
  padding: 0.9rem;

  h4 {
    margin: 0 0 0.4rem;
    color: #ffffff;
    font-size: 0.92rem;
  }

  p {
    color: #cbd5e1;
    font-size: 0.86rem;
    line-height: 1.65;
  }
`;
